// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0bd5fc2f","453":"a58bd9b5"}[chunkId] + ".chunk.js";
};